import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  hideNavBar: boolean;
  sidebarCollapsed: boolean;
}

const initialState: UIState = {
  hideNavBar: false,
  sidebarCollapsed: true,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setHideNavBar: (state, action: PayloadAction<boolean>) => {
      state.hideNavBar = action.payload;
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload;
    },
  },
});

export const { setHideNavBar, setSidebarCollapsed } = uiSlice.actions;
export default uiSlice.reducer;

